<p-toolbar class="align-items-center" styleClass="viewer-toolbar">
  <div class="p-toolbar-group-left">
    <span>{{document?.filename}}</span>
  </div>
</p-toolbar>

<div class="flex flex-1 flex-row">

  <div id="pdfPane" [class.metadata-open]="metadataVisible" [class.pdf-readonly]="document?.state?.name === ArchiveDocumentState.DONE">
    @if (thePdfContent && document) {
      <ngx-extended-pdf-viewer
        [src]="thePdfContent"
        [customThumbnail]="pdfThumbnail"
        [theme]="prefersDarkMode ? 'dark' : 'light'"
        [rotation]="0"
        zoom="page-fit"
        [language]="locale"
        [showToolbar]="true"
        [showSidebarButton]="true"
        [sidebarVisible]="true"
        [showFindButton]="true"
        [showPagingButtons]="true"
        [showBorders]="true"
        [showDrawEditor]="false"
        [showStampEditor]="false"
        [showHighlightEditor]="false"
        [showTextEditor]="false"
        [showZoomButtons]="true"
        [showPresentationModeButton]="true"
        [showOpenFileButton]="false"
        [showPrintButton]="false"
        [showDownloadButton]="true"
        [showSecondaryToolbarButton]="true"
        [showRotateCwButton]="true"
        [showRotateCcwButton]="true"
        [showHandToolButton]="true"
        [showScrollingButtons]="false"
        [filenameForDownload]="document.filename"
        [showSpreadButton]="false"
        (pagesLoaded)="doPagesLoaded($event)"
        (thumbnailDrawn)="onThumbnailDrawn($event)"
        (pdfLoadingFailed)="onPdfLoadingFailed($event)"
        [showPropertiesButton]="false">
      </ngx-extended-pdf-viewer>
    }


    <ng-template #pdfThumbnail>
      <div class="pdf-viewer-template">
        <div class="thumbnail" style="border: 0px solid transparent; height: auto; margin-bottom: 0;">

          <div style="display: flex">
            <div class="image-container" style="width: var(--thumbnail-width); height: auto;">
              <img class="thumbnailImage" alt="pdf thumbnail"/>
            </div>
            <div class="align-content-center delete-div">
              <i class="fa-solid fa-trash ml-2 thumbnail-icon" i18n-title="@@viewer-delete_page" title="Delete page"
                (click)="onDeletePage($event)" data-page-number="PAGE_NUMBER">
              </i>
            </div>
          </div>

          <div class="text-center text-black cut-div">
            <i class="fa-solid fa-scissors mt-2 mb-1 thumbnail-icon" i18n-title="@@viewer-split_here" title="Split here"
              (click)="onDoSplitClick($event)" data-page-number="PAGE_NUMBER">
            </i>
          </div>
        </div>
      </div>
    </ng-template>
  </div>

  <!-- open metadata button -->
  @if (!metadataVisible) {
    <button pButton pRipple (click)="metadataVisible=true" [text]="true" icon="fa fa-solid fa-chevron-left"></button>
  }

  <!-- sidebar containing metadata -->
  <p-drawer [(visible)]="metadataVisible" styleClass="metadata-slider" [modal]="false" [dismissible]="false" [closeOnEscape]="false" position="right">
    <!-- metadata component -->
    <app-metadata></app-metadata>
  </p-drawer>

</div>

